<template>
  <div>
    <EventDateTime
      v-if="showDate"
      v-model="value.eventDate"
      :action="action"
      :data-test-id="$testId('eventDateTime')"
      @dateIsInvalid="handleDateIsInvalid"
    />
    <FieldsSendEmail
      v-model="value.emailSettings"
      :data-test-id="$testId('fieldsSendEmail')"
      :displayInline="displayInline"
      :inMainPanel="inMainPanel"
      :sendEmailWhenActivated="sendEmailWhenActivated"
    />
  </div>
</template>

<script>
import EventDateTime from 'client/systemusers/components/EventDateTime.vue';
import FieldsSendEmail from 'client/systemusers/components/FieldsSendEmail.vue';
import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

export default {
  name: 'FieldsScheduleActivation',

  components: {
    EventDateTime,
    FieldsSendEmail,
  },

  props: {
    action: {
      type: String,
      default: '',
    },

    displayInline: Boolean,
    inMainPanel: Boolean,
    sendEmailWhenActivated: Boolean,
    showDate: Boolean,

    value: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    emailSettings: {
      ...createComputedObjectBinding('emailSettings'),
    },

    eventDate: {
      ...createComputedObjectBinding('eventDate'),
    },
  },

  methods: {
    handleDateIsInvalid(value) {
      this.$emit('dateIsInvalid', value);
    },
  },
};
</script>
